<template>
    <!-- 标签页组件 -->
    <el-tabs
    class="vel-tab"
    v-model="activeName" 
    :type="type"
    :tab-position="tabPosition"
    @tab-click="tabClick"
    >
        <template v-for="(tab,tInx) in tabList">
            <el-tab-pane 
            :label="tab.label" 
            :name="tab.name" 
            :disabled="tab.disabled"
            :lazy="tab.lazy"
            :closable="tab.closable"
            :key="tab.name + tInx"
            >   
                <!-- label插槽 -->
                <span slot="label">
                    <!-- 标志 -->
                    <VelBadge 
                    v-if="badge||tab.isBadge"
                    :value="tab.value" 
                    :max="tab.max"
                    :is-dot="tab.isDot"
                    :type="tab.type"
                    >
                        <VelIcon :iconName=" tab.icon" />
                        {{tab.label}}
                    </VelBadge>
                    <span v-else>
                        <VelIcon :iconName=" tab.icon" />
                        {{tab.label}}
                    </span>
                </span>
                <!-- tab-pane插槽 -->
                <slot :name="tab.name">
                    {{tab.label}}
                </slot>
            </el-tab-pane>
        </template>
    </el-tabs>
</template>
<script>
import VelIcon from '../icon'
import VelBadge from '../badge'
export default {
    name:"VelTabs",
    components:{
        VelIcon,
        VelBadge
    },
    props:{
        initValue:String,
        type:String,
        tabPosition:String,
        isBadge:Boolean,
        tabList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            activeName:'',
            badge:false,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.activeName = newval
            },
            deep:true,
            immediate:true,
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isBadge ? this.badge = true : this.badge
        },
        getValue(){
            this.initValue ? this.activeName = this.initValue :
            this.activeName = this.tabList[0].name
            
        },
        tabClick(vnode){
            this.$emit('tabClick',vnode)
        }
    }
}
</script>
<style scoped>
::v-deep .el-badge__content.is-fixed {
    top: 10px;
}
</style>